'use cilent'
import useScreenSize from '@/app/hooks/useScreenSize'
import { useParams, usePathname } from 'next/navigation'
import React from 'react'
import CompanyDetailCard from '../../../components/(MiniWebsite)/CompanyDetailCard'
import PrePostHarvestNavBar from '../PrePostHarvestNavBar'

const PrePostHarvestComponent = ({ tab }: { tab: React.ReactNode }) => {
  const params = useParams<{ id: string }>()
  const pathName = usePathname()
  const screenSize = useScreenSize()
  return (
    <div>
      <PrePostHarvestNavBar />
      <div className="flex mobile:flex-col mobile-width">
        <div>
          {(screenSize.width >= 768 ||
            pathName.split('/')[pathName.split('/').length - 1] ===
              'profile') && (
            <CompanyDetailCard
              id={params?.id}
              companyIndustryType="pre-post-harvest"
            />
          )}
        </div>
        <div className="pl-[25px] pt-[25px] mobile:pl-0">{tab}</div>
      </div>
    </div>
  )
}

export default PrePostHarvestComponent
